export function updateIsShowGuestLoginFlag(isShowBrowsStore) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'UPDATE_IS_SHOW_GUEST_LOGIN_FLAG',
                payload: isShowBrowsStore
            });
            resolve(true)
        });
    }
};

export const resetWelcomePageTiles = () => ({
    type: 'RESET_WELCOME_PAGE_TILES'
});